export default "__VITE_ASSET__DTG7hbAB__"